import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Path a nav tab for the `prefix` section should link to (PD-1206):
 *
 * - outside the section — the last page visited there, so the Fax tab reopens
 *   the fax that was open before the user navigated away;
 * - already inside the section — the current path and query, so native modified
 *   and non-primary clicks open the page the anchor says they will.
 *
 * In-memory only: the memory lives as long as the component holding the hook,
 * so a full page reload starts from `prefix` again.
 */
export function useSectionNavPath(prefix: string): string {
  const { pathname, search } = useLocation()
  const [lastPath, setLastPath] = useState(prefix)
  const inSection = pathname === prefix || pathname.startsWith(`${prefix}/`)
  const currentPath = `${pathname}${search}`

  useEffect(() => {
    if (inSection) {
      setLastPath(currentPath)
    }
  }, [currentPath, inSection])

  return inSection ? currentPath : lastPath
}
